import classNames from "classnames";
import React from "react";
import SlickSlider, { ResponsiveObject } from "react-slick";

import SliderArrowButton from "./SliderArrowButton";

interface SliderProps<T> {
  className?: string;
  width: "normal" | "wide";
  items: T[];
  getItemKey: (item: T) => string;
  renderItem: (item: T) => React.ReactNode;
}

const responsiveSettings: ResponsiveObject[] = [
  {
    breakpoint: 1024,
    settings: {
      adaptiveHeight: true,
      slidesToShow: 1
    }
  },
  {
    breakpoint: 640,
    settings: {
      adaptiveHeight: true,
      slidesToShow: 1,
      arrows: false
    }
  }
];

const Slider = <T extends unknown>({
  className,
  width,
  items,
  getItemKey,
  renderItem
}: SliderProps<T>) => {
  if (!items?.length) {
    return null;
  }

  return (
    <SlickSlider
      dots
      arrows
      adaptiveHeight={width === "wide" || undefined}
      prevArrow={<SliderArrowButton />}
      nextArrow={<SliderArrowButton />}
      responsive={responsiveSettings}
      slidesToShow={width === "normal" ? 3 : 1}
      slidesToScroll={1}
      initialSlide={0}
      className={classNames("reviews__slider", className)}
      dotsClass="slick-dots reviews__slider-dots"
      infinite={false}
    >
      {items?.map(item => (
        <div key={getItemKey(item)}>{renderItem(item)}</div>
      ))}
    </SlickSlider>
  );
};

export default Slider;

